"use client";

import { Checkbox as BaseCheckbox } from "@base-ui/react/checkbox";
import { cn } from "@shared/lib/cn";
import { CheckIcon, MinusIcon } from "lucide-react";
import type * as React from "react";

function Checkbox({
  className,
  checked,
  indeterminate,
  ...props
}: Omit<React.ComponentProps<typeof BaseCheckbox.Root>, "checked"> & {
  checked?: boolean | "indeterminate";
}) {
  const isIndeterminate = checked === "indeterminate" || indeterminate === true;

  return (
    <BaseCheckbox.Root
      data-slot="checkbox"
      checked={isIndeterminate ? false : checked}
      indeterminate={isIndeterminate}
      className={cn(
        "peer border-input dark:bg-input/30 data-checked:bg-primary data-checked:text-primary-foreground dark:data-checked:bg-primary data-checked:border-primary data-indeterminate:bg-primary data-indeterminate:text-primary-foreground dark:data-indeterminate:bg-primary data-indeterminate:border-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive size-4 shrink-0 rounded-[4px] border shadow-xs transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    >
      <BaseCheckbox.Indicator
        data-slot="checkbox-indicator"
        className="flex items-center justify-center text-current transition-none data-unchecked:hidden"
      >
        {isIndeterminate ? (
          <MinusIcon className="size-3.5" data-slot="checkbox-indeterminate-icon" />
        ) : (
          <CheckIcon className="size-3.5" data-slot="checkbox-check-icon" />
        )}
      </BaseCheckbox.Indicator>
    </BaseCheckbox.Root>
  );
}

export { Checkbox };
